(function () {
  const countryUrlMap = {
    us: {origin: "https://us.aqara.com", pathname: "/"},
    ca: {origin: "https://us.aqara.com", pathname: "/en-ca"},
    gb: {origin: "https://eu.aqara.com", pathname: "/"},
    de: {origin: "https://eu.aqara.com", pathname: "/de-eu"},
    fr: {origin: "https://eu.aqara.com", pathname: "/fr-eu"},
    es: {origin: "https://eu.aqara.com", pathname: "/es-eu"},
    it: {origin: "https://eu.aqara.com", pathname: "/it-eu"},
  };

  function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    const { hostname } = window.location;
    const domain = hostname.includes("test") ? "" : "domain=.aqara.com;";
    const path = "path=/";
    document.cookie = name + "=" + value + ";" + expires + ";" + domain + path;
  }
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getCountry() {
    return fetch("https://get.geojs.io/v1/ip/geo.json")
      .then((response) => response.json())
      .then((data) => {
        return data.country_code.toLowerCase();
      })
      .catch((error) => {
        console.error("Error fetching country code:", error);
        return "gb"; // Default to United kingdom if there's an error
      });
  }

  function addChangeSiteDom(countryCode) {

    if (document.getElementById("change-site-dom")) {
      return;
    }

    const changeSiteDom = document.createElement("div");
    changeSiteDom.id = "change-site-dom";
    changeSiteDom.classList.add("header__wrapper");

    const textNode = document.createTextNode("Select another country or region to get content and online shopping options that apply to your location");
    changeSiteDom.appendChild(textNode);

    const select = addSimulateSelect(countryCode);
    changeSiteDom.appendChild(select);

    const button = addChangeSiteButton();
    changeSiteDom.appendChild(button);

    const closeIcon = addCloseIcon();
    changeSiteDom.appendChild(closeIcon);

    const headerItem = document.querySelector(".shopify-section-group-group-header");
    headerItem.parentNode.insertBefore(changeSiteDom, headerItem);
  }

  function addSimulateSelect(countryCode) {
    const simulateSelectWrapper = document.createElement("div");
    simulateSelectWrapper.classList.add("change-site-simulate-select-wrapper");

    const simulateSelect = document.createElement("button");
    simulateSelect.type = "button";
    simulateSelect.id = "change-site-simulate-select";
    simulateSelect.setAttribute("aria-haspopup", "listbox");
    simulateSelect.setAttribute("aria-expanded", "false");
    simulateSelect.setAttribute("aria-controls", "change-site-simulate-option");

    const options = [
      { value: "us", text: "United States" },
      { value: "ca", text: "Canada" },
      { value: "gb", text: "United Kingdom" },
      { value: "fr", text: "France" },
      { value: "de", text: "Germany" },
      { value: "es", text: "Spain" },
      { value: "it", text: "Italy" },
    ];

    const curSelectShow = document.createElement("span");
    curSelectShow.id = "change-site-simulate-text";

    const selectText = document.createElement("span");
    selectText.id = "change-site-simulate-span";
    selectText.textContent = options.find((option) => option.value === countryCode)?.text || "United Kingdom";
    selectText.dataset.value = options.find((option) => option.value === countryCode)?.value || "gb";;
    curSelectShow.appendChild(selectText);

    const selectIcon = document.createElementNS('http://www.w3.org/2000/svg', "svg");
    selectIcon.id = "change-site-simulate-icon";
    selectIcon.setAttribute("viewBox", "0 0 24 24");
    selectIcon.setAttribute("width", "24");
    selectIcon.setAttribute("height", "24");
    selectIcon.innerHTML = `<path d="M6 9l6 6 6-6" />`;
    curSelectShow.appendChild(selectIcon);

    simulateSelect.appendChild(curSelectShow);
    simulateSelectWrapper.appendChild(simulateSelect);

    const optionUl = document.createElement("ul");
    optionUl.id = "change-site-simulate-option";
    optionUl.setAttribute("role", "listbox");
    let activeIndex = Math.max(0, options.findIndex((option) => option.value === selectText.dataset.value));
    options.forEach((option, index) => {
      const opt = document.createElement("li");
      opt.id = `change-site-option-${option.value}`;
      opt.textContent = option.text;
      opt.dataset.value = option.value;
      opt.setAttribute("role", "option");
      if (index === activeIndex) {
        opt.classList.add("selected");
        opt.setAttribute("aria-selected", "true");
      } else {
        opt.setAttribute("aria-selected", "false");
      }
      optionUl.appendChild(opt);
    });

    const optionElements = Array.from(optionUl.querySelectorAll('[role="option"]'));
    const setExpanded = (expanded) => {
      optionUl.style.display = expanded ? "block" : "none";
      simulateSelect.setAttribute("aria-expanded", String(expanded));
      selectIcon.innerHTML = expanded
        ? `<path d="M6 15l6-6 6 6" />`
        : `<path d="M6 9l6 6 6-6" />`;
      if (expanded) {
        simulateSelect.setAttribute("aria-activedescendant", optionElements[activeIndex].id);
        optionElements[activeIndex].scrollIntoView({ block: "nearest" });
      } else {
        simulateSelect.removeAttribute("aria-activedescendant");
      }
    };
    const selectOption = (index) => {
      activeIndex = (index + optionElements.length) % optionElements.length;
      optionElements.forEach((option, optionIndex) => {
        const selected = optionIndex === activeIndex;
        option.classList.toggle("selected", selected);
        option.setAttribute("aria-selected", String(selected));
      });
      const selectedOption = optionElements[activeIndex];
      selectText.textContent = selectedOption.textContent;
      selectText.dataset.value = selectedOption.dataset.value;
      simulateSelect.setAttribute("aria-activedescendant", selectedOption.id);
      selectedOption.scrollIntoView({ block: "nearest" });
    };
    optionUl.addEventListener("click", (event) => {
      const selectedOption = event.target.closest('[role="option"]');
      if (selectedOption) {
        selectOption(optionElements.indexOf(selectedOption));
        setExpanded(false);
        simulateSelect.focus();
      }
    });
    simulateSelectWrapper.appendChild(optionUl);

    simulateSelect.addEventListener("click", () => {
      setExpanded(simulateSelect.getAttribute("aria-expanded") !== "true");
    });
    simulateSelect.addEventListener("keydown", (event) => {
      const expanded = simulateSelect.getAttribute("aria-expanded") === "true";
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        if (!expanded) setExpanded(true);
        selectOption(activeIndex + (event.key === "ArrowDown" ? 1 : -1));
      } else if (event.key === "Home" || event.key === "End") {
        event.preventDefault();
        if (!expanded) setExpanded(true);
        selectOption(event.key === "Home" ? 0 : optionElements.length - 1);
      } else if (event.key === "Escape" && expanded) {
        event.preventDefault();
        setExpanded(false);
      } else if ((event.key === "Enter" || event.key === " ") && expanded) {
        event.preventDefault();
        setExpanded(false);
      } else if (event.key === "Tab" && expanded) {
        setExpanded(false);
      }
    });
    document.addEventListener("click", (event) => {
      const simulateSelect = document.getElementById("change-site-simulate-select");
      const wrapper = simulateSelect?.closest(".change-site-simulate-select-wrapper");
      if (simulateSelect && wrapper && !wrapper.contains(event.target)) {
        const ul = document.getElementById("change-site-simulate-option");
        if (ul) {
          setExpanded(false);
        }
      }
    });

    return simulateSelectWrapper;
  }

  function addChangeSiteButton() {
    const button = document.createElement("button");
    button.id = "change-site-confirm-button";
    button.textContent = "Select";

    button.addEventListener("click", () => {
      const selectedCountryCode = document.getElementById("change-site-simulate-span").dataset.value;
      console.log("Selected country code:", selectedCountryCode);
      const curTime = new Date().getTime();
      setCookie("closeChangeSiteTime", curTime, 24);
      let href = `${countryUrlMap[selectedCountryCode].origin}${countryUrlMap[selectedCountryCode].pathname}`;
      window.location.href = href;
    });
    return button;
  }

  function addCloseIcon() {
    const closeIcon = document.createElement("button");
    closeIcon.type = "button";
    closeIcon.id = "change-site-close-icon";
    closeIcon.setAttribute("aria-label", "Close country or region selector");
    closeIcon.textContent = "×";
    closeIcon.addEventListener("click", () => {
      const changeSiteDom = document.getElementById("change-site-dom");
      if (!changeSiteDom) {
        return;
      }
      document.body.removeChild(changeSiteDom);
      const curTime = new Date().getTime();
      setCookie("closeChangeSiteTime", curTime, 24);
    });
    return closeIcon;
  }

  getCountry().then((countryCode) => {
    let {href} = window.location;
    if (countryUrlMap[countryCode]) {
      href = `${countryUrlMap[countryCode].origin}${countryUrlMap[countryCode].pathname}`;
    }
    if (window.location.href.includes(href)) {
      return;
    }
    const closeChangeSiteTime = getCookie("closeChangeSiteTime");
    if (closeChangeSiteTime) {
      return;
    }
    addChangeSiteDom(countryCode);
  })
})();
